import Modal from "react-bootstrap/Modal";
import ThankYouCard from "./ThankYouCard";
import {AddChildCloseIcon} from "./ThankYouStyle";
import close from "../../../images/circle_close_icon.svg";
import "../../../styles/Common.css";

function WorldMapCelebrationPopup({show, onHide, celebrationProjects, onSeenChildrenChange}) {
  if (!show || !celebrationProjects || celebrationProjects.length === 0) {
     return null;
  }
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}
      className="celebrationPopup"
    >
      <Modal.Body>
      <AddChildCloseIcon onClick={onHide}><img src={close} alt="close"/></AddChildCloseIcon>
      <ThankYouCard
          celebrationProjects={celebrationProjects}
          onSeenChildrenChange={onSeenChildrenChange}
        />
      </Modal.Body>
    </Modal>
  );
}
export default WorldMapCelebrationPopup;